import { useAuth } from 'contexts/auth';

import type { CompanyFeatureFlagType } from 'api/api.types';

export function useCompanyFeatureFlags<K extends CompanyFeatureFlagType>(
  ...keys: K[]
): Record<K, boolean> {
  const { company } = useAuth();
  return keys.reduce((acc, key) => {
    acc[key] = Boolean(company?.companyData[key]);
    return acc;
  }, {} as Record<K, boolean>);
}
